import React, { useState } from 'react';
type ModalType = 'privacy' | 'terms' | 'contact' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  const closeModal = () => setActiveModal(null);
  const modalContent = {
    privacy: {
      title: 'Política de Privacidad',
      content: <div className="space-y-4 text-sm" data-id="element-57">
          <p data-id="element-58">
            En Protocolo Cero Gritos respetamos tu privacidad y protegemos tus
            datos personales.
          </p>
          <h3 className="font-bold text-base mt-4" data-id="element-59">1. Recopilación de datos</h3>
          <p data-id="element-60">
            Solo recopilamos los datos necesarios para procesar tu pedido
            (nombre, email y datos de pago a través de pasarelas seguras).
          </p>
          <h3 className="font-bold text-base mt-4" data-id="element-61">2. Uso de la información</h3>
          <p data-id="element-62">
            Tu email será utilizado exclusivamente para enviarte el acceso al
            producto adquirido y comunicaciones relacionadas con el mismo.
          </p>
          <h3 className="font-bold text-base mt-4" data-id="element-63">3. Tus derechos</h3>
          <p data-id="element-64">
            Puedes solicitar el acceso, rectificación o eliminación de tus datos
            en cualquier momento contactando con nuestro soporte.
          </p>
        </div>
    },
    terms: {
      title: 'Términos y Condiciones',
      content: <div className="space-y-4 text-sm" data-id="element-65">
          <p data-id="element-66">
            Al adquirir el Protocolo Cero Gritos, aceptas los siguientes
            términos:
          </p>
          <h3 className="font-bold text-base mt-4" data-id="element-67">1. Propiedad Intelectual</h3>
          <p data-id="element-68">
            El contenido del manual y los bonos es propiedad exclusiva de sus
            creadores. Queda prohibida su distribución, reventa o reproducción
            sin autorización.
          </p>
          <h3 className="font-bold text-base mt-4" data-id="element-69">
            2. Naturaleza del producto
          </h3>
          <p data-id="element-70">
            Este es un producto digital (infoproducto). El acceso se otorga de
            forma inmediata tras la confirmación del pago.
          </p>
          <h3 className="font-bold text-base mt-4" data-id="element-71">
            3. Exención de responsabilidad
          </h3>
          <p data-id="element-72">
            Las estrategias compartidas tienen fines educativos. No sustituyen
            el consejo de un profesional de la salud mental o pediatra.
          </p>
        </div>
    },
    contact: {
      title: 'Contacto',
      content: <div className="space-y-4 text-center py-4" data-id="element-73">
          <p data-id="element-74">¿Tienes alguna duda o problema con tu acceso?</p>
          <p data-id="element-75">
            Escríbenos a nuestro correo de soporte y te atenderemos lo antes
            posible:
          </p>
          <a href="mailto:electronicecomjj@gmail.com" className="inline-block mt-4 px-6 py-3 bg-warm-accent text-white font-bold rounded-full hover:bg-[#E89B3E] transition-colors" data-id="element-76">
            electronicecomjj@gmail.com
          </a>
        </div>
    }
  };
  return <>
      <footer className="bg-deep-blue py-12 text-center text-cream/60 text-sm border-t border-deep-blue-light/30" data-id="element-77">
        <div className="max-w-4xl mx-auto px-4" data-id="element-78">
          <p className="mb-6" data-id="element-79">
            © 2026 Protocolo Cero Gritos. Todos los derechos reservados.
          </p>
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-3" data-id="element-80">
            <button onClick={() => setActiveModal('privacy')} className="hover:text-warm-accent transition-colors underline underline-offset-4" data-id="element-81">
              Política de Privacidad
            </button>
            <button onClick={() => setActiveModal('terms')} className="hover:text-warm-accent transition-colors underline underline-offset-4" data-id="element-82">
              Términos y Condiciones
            </button>
            <button onClick={() => setActiveModal('contact')} className="hover:text-warm-accent transition-colors underline underline-offset-4" data-id="element-83">
              Contacto
            </button>
          </div>
        </div>
      </footer>

      {/* Modal Overlay */}
      {activeModal && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-deep-blue/80 backdrop-blur-sm animate-fade-in-up" style={{
      animationDuration: '0.2s'
    }} data-id="element-84">
          <div className="bg-white rounded-2xl p-6 md:p-8 max-w-lg w-full max-h-[80vh] overflow-y-auto relative shadow-2xl" data-id="element-85">
            <button onClick={closeModal} className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center rounded-full bg-gray-100 text-gray-500 hover:bg-gray-200 hover:text-gray-800 transition-colors" aria-label="Cerrar" data-id="element-86">
              ✕
            </button>
            <h2 className="text-2xl font-bold mb-6 text-deep-blue border-b pb-4" data-id="element-87">
              {modalContent[activeModal].title}
            </h2>
            <div className="text-deep-blue/80" data-id="element-88">
              {modalContent[activeModal].content}
            </div>
          </div>
        </div>}
    </>;
}